"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var react_2 = require("react");
var useClient_1 = require("../../../../../../hooks/useClient");
function useRenderCellViews() {
    var client = (0, useClient_1.useClient)().client;
    function PriceCellView(_a) {
        var _b;
        var cellValue = _a.cellValue, client = _a.client;
        if (!client) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, utils_1.formatMoney)({
                symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
                value: (_b = cellValue === null || cellValue === void 0 ? void 0 : cellValue.toString()) !== null && _b !== void 0 ? _b : "0",
                symbolSeparation: true,
            }) }));
    }
    var renderCellViews = (0, react_2.useCallback)(function (cellValue) {
        return [
            { key: "name", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: cellValue || "Unnamed" }) },
            { key: "statistic", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }) },
            {
                key: "earn_source",
                content: ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "soft", color: cellValue === "gifts" ? "default" : cellValue === "subscriptions" ? "warning" : "accent", children: cellValue === "gifts" ? "Gift Cards" : cellValue === "subscriptions" ? "Subscriptions" : "Orders" })),
            },
            { key: "earn_value", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: cellValue }) },
            { key: "trigger_value", content: (0, jsx_runtime_1.jsx)(PriceCellView, { cellValue: cellValue, client: client }) },
            { key: "earn_target", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }) },
            { key: "earn_amount", content: (0, jsx_runtime_1.jsx)(PriceCellView, { cellValue: cellValue, client: client }) },
            { key: "excluded_category_ids", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue === null || cellValue === void 0 ? void 0 : cellValue.length }) },
            { key: "excluded_product_ids", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue === null || cellValue === void 0 ? void 0 : cellValue.length }) },
        ];
    }, [client]);
    return (0, react_2.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
